import React from "react";
import NotFoundUI from "./NotFoundUI";

const NotFound = () => {
  return <NotFoundUI />;
};

export default NotFound;
